import { Injectable, inject } from '@angular/core';
import { select, Store, Action } from '@ngrx/store';

import * as DashboardActions from './dashboard.actions';
import * as DashboardSelectors from './dashboard.selectors';

@Injectable()
export class DashboardFacade {
  private readonly store = inject(Store);

  /**
   * Combine pieces of state using createSelector,
   * and expose them as observables through the facade.
   */

  getDashboardData$ = this.store.pipe(select(DashboardSelectors.GetUserDashboardData));

  GetDashboardData() {
    this.store.dispatch(DashboardActions.getDashboardData());
  }

  clearDashboradData() {
    this.store.dispatch(DashboardActions.clearUserDashboardData());
  }
}
